module.exports = __webpack_public_path__ + "static/cpc_company-b0ed4236675aa81300e39a7da3a3396b.svg";